export default {
    'Change orientation': 'Cambiar la orientación',
}